import api from 'api'
import {mergeRight} from 'ramda'
import moment from 'moment'

export getStats = (user, members = 15) ->
  api.get "/peerconversations/cplstats", params: {organizationCode: user.org.code, minMembers: members}
